import BaseMapper from '../../BaseMapper';

const EventMarketUpdateMapper = (data, context) => {
    return data;
};

export default EventMarketUpdateMapper;
